import Link from "gatsby-link"
import React from "react"

import logo from "../../assets/svg/logo.svg"
import styles from "../../styles/header.module.styl"

export default () => (
  <Link className={styles.ashLogoLink} to="/vte">
    <img className={styles.ashLogo} src={logo} alt="logo" />
  </Link>
)
